<div class="toolbar">
  <button matButton="text" class="toolbar-button" (click)="backToEntity()" [disabled]="isBusy()">
    <span>
      <mat-icon class="toolbar-icon">keyboard_arrow_left</mat-icon>
      <label>Back</label>
    </span>
  </button>
  <button matButton="text" class="toolbar-button" (click)="openPerformanceDefaultsDialog()" [disabled]="isBusy()">
    <span>
      <mat-icon class="toolbar-icon">speed</mat-icon>
      <label>Performance Defaults</label>
    </span>
  </button>
  <span class="spacer"></span>
</div>
<div class="errorMessageWrapper">
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
</div>
<div class="content">
  <div class="leftPanel">
    <div class="buttonContainer">
      <div class="buttonRow">
        <button matButton="elevated" class="inputButton" (click)="addUnit()" [disabled]="addUnitDisabled()">
          Add
        </button>
        <button matButton="elevated" class="inputButton" (click)="deleteLine()" [disabled]="deleteUnitDisabled()">
          Delete
        </button>
        <button matButton="elevated" class="inputButton" (click)="copyLine()" [disabled]="copyLineDisabled()">
          Copy
        </button>
      </div>
      <div class="buttonRow">
        <button matButton="elevated" class="inputButton" (click)="saveUnit()" [disabled]="saveUnitDisabled()">
          Save
        </button>
        <button matButton="elevated" class="inputButton" (click)="saveAll()" [disabled]="saveAllDisabled()">
          Save All
        </button>
        <span matTooltip="Please save all changes before mass updating selections"
          [matTooltipDisabled]="!massUpdateDisabled()">
          <button matButton="elevated" class="inputButton" (click)="massUpdate()"
            [disabled]="massUpdateDisabled()">
            Mass Update
          </button>
        </span>
      </div>
    </div>
    <div class="listContainer">
      <div cdkDropList class="entityLineList" (cdkDropListDropped)="lineItemDropped($event)">
        @for (line of entityLines(); track line) {
          <div [class.changed]="isLineUpdated(line)" [class.selected]="isLineSelected(line)"
            [class.incomplete]="!line.configurationComplete" [class.invalidTags]="!lineTagsValid(line)"
            (click)="loadLineDetail(line)" class="entityLineListEntry"
            cdkDrag>
            <label class="descriptionField">{{ line.lineId + '_' + line.description }}</label>
            <label class="quantityField">{{ line.quantity }}</label>
            <label class="tagsField">{{ line.tags }}</label>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="rightPanel">
    <ng-template #modelDetail></ng-template>
  </div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
